<div class="idp-button-with-link idp-button-with-link--wrapper">
  <div class="idp-button-with-link--container">
    <div class="section__col-12 cta-button">
      <idp-button
        (notify)="notify($event, 'button')"
        [label]="buttonLabel"
        size="extra-wide"
      ></idp-button>
    </div>
    <div class="section__col-12 cta-link">
      <idp-label-with-link
        (clicked)="notify($event, 'link')"
        [description]="description"
        [linkLabel]="linkLabel"
      ></idp-label-with-link>
    </div>
  </div>
</div>
